<script>
import moment from "moment";

export default {
  name: "CertificadosDigitais",
  props: {
    certificados: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showAdicionarModal: false,
      showExcluirModal: false,
      certificadoExcluir: null
    }
  },
  filters: {
    date(value) {
      return moment(value).format('DD/MM/YYYY');
    }
  },
  methods: {
    abrirExcluirModal(certificado) {
      this.certificadoExcluir = certificado;
      this.showExcluirModal = true;
    },
    fecharExcluirModal() {
      this.showExcluirModal = false;
    },
    abrirAdicionarModal() {
      this.showAdicionarModal = true;
    },
    fecharAdicionarModal() {
      this.showAdicionarModal = false;
    },
    textoBotaoAutenticacao(certificado) {
      const quantidade = Object.keys((certificado && certificado.tribunais) ? certificado.tribunais : {}).length;
      if (quantidade === 0 ) {
        return 'Gerir métodos';
      }
      const sufixoPlural = quantidade > 1 ? 's' : '';
      return `${quantidade} método${sufixoPlural} configurado${sufixoPlural}`;
    }
  },
}
</script>

<template>
  <div>
    <div class="flex justify-between separate-section">
      <h1 class="text-2xl font-bold">Certificados Digitais</h1>
      <div>
        <btn class="btn info -right upper" @click="abrirAdicionarModal">
          + ADICIONAR CERTIFICADO
        </btn>
      </div>
    </div>

    <div class="mt">
      <p>
        Você pode registrar seus certificados digitais da OAB para
        utilizá-los na visualização de autos.
      </p>

      <div class="col-md-12">
        <table class="text-left w-full mt-4 block sm:table overflow-x-auto">
          <thead>
          <tr class="text-xs font-medium text-gray-400 uppercase">
            <th class="w-16 pb-4 pr-2">ID</th>
            <th class="pb-4 px-2">Nome</th>
            <th class="pb-4 px-2">CPF</th>
            <th class="pb-4 px-2 whitespace-nowrap">Data de cadastro</th>
            <th class="pb-4 px-2 whitespace-nowrap">Data de expiração</th>
            <th class="pb-4 px-2 whitespace-nowrap">Autenticação Multifator</th>
            <th class="pb-4 px-2 whitespace-nowrap">Ações</th>
          </tr>
          </thead>
          <tbody v-if="certificados?.length">
          <tr v-for="certificado in certificados">
            <td class="text-sm p-2">{{ certificado['id'] }}</td>
            <td class="max-w-[240px] text-ellipsis whitespace-nowrap overflow-hidden text-sm p-2">{{ certificado['pessoa_nome'].toUpperCase() }}</td>
            <td class="max-w-[240px] text-ellipsis whitespace-nowrap overflow-hidden text-sm p-2">{{ certificado['pessoa_cpf'] }}</td>
            <td class="text-sm p-2">{{ certificado['created_at'] | date }}</td>
            <td class="text-sm p-2">{{ certificado['data_expiracao'] | date }}</td>
            <td class="max-w-[245px] text-ellipsis whitespace-nowrap overflow-hidden p-2">
              <btn class="btn info v--outline upper" :href="`/certificados/${certificado['id']}/metodos-autenticacao`">
                {{ textoBotaoAutenticacao(certificado) }}
              </btn>
            </td>
            <td>
              <btn
                class="btn negative upper"
                @click="abrirExcluirModal(certificado)"
              >
                Remover
              </btn>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="9" style="text-align: center">
              Você ainda não registrou nenhum certificado digital da OAB.
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <adicionar-certificado-digital-modal
      :visible="showAdicionarModal"
      @closeModal="fecharAdicionarModal"
    />
    <excluir-certificado-digital-modal
      :visible="showExcluirModal"
      :certificado="certificadoExcluir"
      @closeModal="fecharExcluirModal"
    />

  </div>
</template>

<style scoped lang="stylus">

</style>
